import { arrow } from "../../assets/icons"

export default function BackArrow(){
    return (
        <a href="/" className="absolute left-10 top-10">{arrow}</a>
    )
}